export default class UserProfileParamsFormatter {
    static format(formFields) {
        let params = this._copyMainParams(formFields);
            this._setUserLocation(params, formFields);

        return params;
    }

    static _copyMainParams(formFields) {
        return {
            id: formFields.id,
            email: formFields.email,
            name: formFields.name,
            workingTitle: formFields.workingTitle,
            phone: formFields.phone,
            mobilePhone: formFields.mobilePhone,
            directPhoneNumber: formFields.directPhoneNumber,
            linkedIn: formFields.linkedIn,
            isAdmin: formFields.isAdmin,
        };
    }

    static _setUserLocation(params, formFields) {
        params.location = {
            addressId: formFields.addressId,
            regionId: formFields.regionId,
            municipalityId: formFields.municipalityId,
            city: formFields.city,
            postalCode: formFields.postalCode,
            countryId: 1,
        }
    }
}


// WEBPACK FOOTER //
// ./web/src/services/user/UserProfileParamsFormatter.js